import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogConfigInterface} from 'appShared/components/dialog';
import {AddPlatformFrontendForm} from 'appEntries/panel/forms';
import {ApiError, PlatormFrontendModel, SesService} from '@spa/api';
import {PlatformFrontendFormErrorStatesEnum} from 'appEntries/panel/enums';
import {PlatformFrontendAddMessages} from 'appAssets/messages';
import {AlertsService, CurrencyService} from 'appShared/services';
import {TradingPlatformInfoInterface} from '@spa/api/lib/interfaces';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-platform-frontend-edit',
    templateUrl: './platform-frontend-edit.component.html',
    styleUrls: ['./platform-frontend-edit.component.scss']
})
export class PlatformFrontendEditComponent extends PanelBaseMarketDataFormDialogComponent<PlatformFrontendEditComponent> {

    public platform: PlatormFrontendModel;
    public tradingPlatforms: TradingPlatformInfoInterface[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            tradingPlatforms: TradingPlatformInfoInterface[]
            platform: PlatormFrontendModel
        },
        private readonly sesService: SesService,
        private readonly currencyService: CurrencyService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<PlatformFrontendEditComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.platform = data.platform;
        this.tradingPlatforms = data.tradingPlatforms;
    }

    initForm(): void {
        this.form = new AddPlatformFrontendForm(this.sesService, this.currencyService, this.tradingPlatforms, this.platform);

        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return PlatformFrontendAddMessages.PlatformFrontendUpdateSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === PlatformFrontendFormErrorStatesEnum.UpdatePlatformFrontendFailed) {
            return PlatformFrontendAddMessages.PlatformFrontendUpdateFailed.message;
        }

        return PlatformFrontendAddMessages.UnknownError.message;
    }

}
